// Índices que coinciden exactamente con las columnas del Excel exportado:
// 0=Referencia(skip) 1=Modelo 2=Capacidad 3=Procesador 4=RAM 5=Color
// 6=Grado 7=Condición 8=Salud 9=Ciclos 10=ProblemaOriginal 11=Precio 12=PrecioSinIva
// 13=PrecioCompra 14=CompraSinIva 15=IMEI 16=Serial 17=Estado 18=Vendido
// 19=FechaEntrada(skip) 20=FechaVenta(skip) 21=Observaciones1 22=Observaciones2

export const getColumnsExcel = {
    1:  'modelo',
    2:  'capacidad',
    3:  'procesador',
    4:  'ram',
    5:  'color',
    6:  'grado',
    7:  'condicion',
    8:  'salud',
    9:  'ciclos',
    10: 'problemaOriginal',
    11: 'precio',
    12: 'precioSinIva',
    13: 'precioCompra',
    14: 'precioCompraSinIva',
    15: 'imei',
    16: 'serial',
    17: 'estado',
    18: 'vendido',
    21: 'observaciones1',
    22: 'observaciones2',
};

export const formatColumnExcel = index => {
    const valueDefault  = v => v;
    const valueNumber   = v => v != null ? Number(v.toString().replaceAll(',', '.')) : v;
    const valueBoolean  = v => v === true || v === 'Sí' || v === 'SI' || v === 'si' || v === 1 || v === '1';
    const valueEstado   = v => {
        const map = { 'En stock': 'stock', 'Reparando': 'reparacion', 'Reservado': 'reservado', 'Vendido': 'vendido' };
        return map[v] || v || 'stock';
    };
    const valueCondicion = v => {
        if (!v) return v;
        const lower = v.toString().toLowerCase();
        return lower === 'premium' ? 'premium' : 'usado';
    };
    const map = {
        7:  valueCondicion, // condicion
        11: valueNumber,    // precio
        12: valueNumber,    // precioSinIva
        13: valueNumber,    // precioCompra
        14: valueNumber,    // precioCompraSinIva
        17: valueEstado,    // estado
        18: valueBoolean,   // vendido
    };
    return map[index] || valueDefault;
};
